import { FormInput, TabsNavigation } from 'components/molecules';
import FormSubmitButtons from 'components/molecules/buttons/formSubmitButtons/FormSubmitButtons';
import LabeledStatus from 'components/molecules/labeledStatus/LabeledStatus';
import Tabs from 'components/molecules/tabs';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarTabs } from 'components/templates';
import { Form, Formik, FormikConfig } from 'formik';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { IMerchImageResponse, IMerchMutationForm } from 'services/merch/types';
import { STATUS } from 'services/types';
import { II18nextPrefix } from 'types/components/components.interface';
import { useEnumToSelectOptions } from 'utils/components/inputs/select';
import { array, number, object, string } from 'yup';
import { settlementInfoContractValidation } from '../music-product-digital/MusicProductDigitalForm';
import { IFormProps } from '../types';
import MerchImages from './tabs/MerchImages';

export enum merchTabs {
  data,
  contracts,
}

export const merchInitialValues: IMerchMutationForm = {
  EAN: '',
  id: '',
  name: '',
  statusId: STATUS.draft,
  gallery: { images: [], deleteImages: [], pendingImages: [] },
  contracts: [],
};

export const merchValidator = object().shape({
  name: string().required(() => i18next.t('formik-error.required')),
  EAN: string()
    .matches(/^\d+$/)
    .required(() => i18next.t('formik-error.required')),
  statusId: number().required(() => i18next.t('formik-error.required')),
  contracts: array().of(settlementInfoContractValidation),
});

export const filterImagesByIsMainAndReturnFirst = (images: IMerchImageResponse[]) =>
  images.filter((image) => image.isMain)[0];

export interface IMerchForm extends FormikConfig<IMerchMutationForm>, IFormProps, II18nextPrefix {}

const MerchForm = ({
  i18nextPrefix,
  topbarContent,
  tittle,
  initialValues = merchInitialValues,
  disableTabs,
  backPath,
  customBackItem,
  status,
  ...props
}: IMerchForm) => {
  const { t } = useTranslation();
  const { getStatusOptions } = useEnumToSelectOptions();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <Formik
      {...props}
      validationSchema={merchValidator}
      validateOnChange
      validateOnBlur
      validateOnMount
      initialStatus={status}
      enableReinitialize
      initialValues={initialValues}
    >
      {({ setFieldValue, values, status, errors }) => (
        <Form className="w-full h-full">
          <TopbarTabs>
            <TopBar
              customBackItem={customBackItem}
              title={status?.displayMode ? values.name : undefined}
              path={backPath ?? 'merch'}
              topbarContent={
                <div className=" w-full flex justify-end">
                  {status?.displayMode ? null : (
                    <div className="w-48">
                      <FormInput.Text name="name" label={t('input.label.name')} autoFocus />
                    </div>
                  )}
                  <div className="flex items-center gap-2 w-full justify-end">
                    {status?.displayMode ? (
                      <LabeledStatus status={initialValues.statusId} />
                    ) : (
                      <FormSubmitButtons />
                    )}
                    {topbarContent}
                  </div>
                </div>
              }
            >
              <TabsNavigation
                disabled={[...(disableTabs ?? [])]}
                tabs={[
                  {
                    value: merchTabs.contracts,
                    name: 'contracts',
                    // error: errors.contracts,
                  },
                  {
                    value: merchTabs.data,
                    name: 'data',
                    error: errors.gallery,
                  },
                ]}
              />
            </TopBar>
          </TopbarTabs>
        </Form>
      )}
    </Formik>
  );
};

MerchForm.getRouterTabs = (disabledChildren?: string[]) =>
  [
    { path: 'data', element: <MerchImages /> },
    { path: 'contracts', element: <Tabs.ProductContracts /> },
  ].filter((children) => !disabledChildren?.includes(children.path));

export default MerchForm;
